import { getCookie } from "assets/mcui-js/utils/cookieUtils.js";
import { siteCookieLogicManager } from "./initCookieLogicManager.js";
import { getPageName } from "./getPageName.js";

export async function setPreviousPageCookie() {
  const oldPageNameCookie = getOldPageNameFromCookie();
  //refresh did not happen
  if (oldPageNameCookie !== getPageName()){
    await siteCookieLogicManager.setPreviousPageCookie();
  }
}
export function getOldPageNameFromCookie(){
  return getCookie('PAGENAME') ?? "";
}
const PREVIOUS_PAGE_COOKIE_NAME = 'previous_page_url';
export function getPreviousPageCookie() {
  const previous_page_url = getCookie(PREVIOUS_PAGE_COOKIE_NAME) ?? "";
  return previous_page_url;
}  